import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";
import { supabase } from "@/lib/supabase";
import { useLang } from "@/lib/lang";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { t } = useLang();

  useEffect(() => {
    let settled = false;

    const finish = (path) => {
      if (settled) return;
      settled = true;
      navigate(path, { replace: true });
    };

    const { data: listener } = supabase.auth.onAuthStateChange((event, session) => {
      if (session && event === "SIGNED_IN") {
        finish("/workspace");
      }
    });

    (async () => {
      const { data } = await supabase.auth.getSession();
      if (data.session) {
        finish("/workspace");
        return;
      }

      // Allow Supabase to exchange the OAuth PKCE code from the redirect URL.
      await new Promise((resolve) => setTimeout(resolve, 1500));

      const { data: retry } = await supabase.auth.getSession();
      finish(retry.session ? "/workspace" : "/login");
    })();

    return () => {
      settled = true;
      listener.subscription.unsubscribe();
    };
  }, [navigate]);

  return (
    <div
      data-testid="auth-callback"
      className="min-h-screen flex flex-col items-center justify-center bg-white text-slate-900"
    >
      <BrandLogo size="xl" alt="Adl" className="mb-6" />
      <div className="flex items-center gap-2 text-sm text-slate-600">
        <Loader2 size={14} className="animate-spin" />
        {t("auth_callback_loading")}
      </div>
    </div>
  );
}
